
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino-complaints/[id]",
      function () {
        return require("private-next-pages/casino-complaints/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino-complaints/[id]"])
      });
    }
  